import { Text as NativeText } from 'react-native'

import { styled } from 'nativewind'

import { withFont } from '../../hoc/withFont'


export const Text = styled(NativeText, 'font-[Graphie-Regular]  leading-6', {
  variants: {
    bold: { true: 'font-[Graphie-Bold]' },
    semibold: { true: 'font-[Graphie-SemiBold]' },
  },
})
export const HeadingText = styled(NativeText)

export const H1 = styled(HeadingText, 'font-[Graphie-Bold] text-4xl leading-10')
export const H2 = styled(
  HeadingText,
  'font-[Graphie-Bold] text-[32px] leading-10'
)
export const H3 = styled(
  HeadingText,
  'font-[Graphie-SemiBold] text-2xl leading-8'
)
export const H4 = styled(
  HeadingText,
  'font-[Graphie-SemiBold] text-xl leading-7'
)
export const H5 = styled(
  HeadingText,
  'font-[Graphie-SemiBold] text-lg leading-7'
)
export const H6 = styled(HeadingText, 'font-[Graphie-Bold] text-base leading-6')

//SUBHEADINGS
const BaseSH1 = styled(Text, 'text-base leading-6')
const BaseSH2 = styled(Text, 'text-sm leading-5')
const BaseSH3 = styled(Text, 'text-sm leading-5')
const BaseSH4 = styled(Text, 'text-xs leading-4')

export const SH1 = withFont(BaseSH1, {
  fontDefault: 'Graphie-SemiBold',
  fontForJfsFlow: 'JioType-Medium',
})
export const SH2 = withFont(BaseSH2, {
  fontDefault: 'Graphie-Bold',
  fontForJfsFlow: 'JioType-Bold',
})
export const SH3 = withFont(BaseSH3, {
  fontDefault: 'Graphie-SemiBold',
  fontForJfsFlow: 'JioType-Medium',
})
export const SH4 = withFont(BaseSH4, {
  fontDefault: 'Graphie-Bold',
  fontForJfsFlow: 'JioType-Bold',
})

//BODY
const BaseB1 = styled(Text, 'text-base leading-6')
const BaseB2 = styled(Text, 'text-sm leading-5')
const BaseB3 = styled(Text, 'text-sm leading-5')
const BaseB4 = styled(Text, 'text-xs')
const BaseB5 = styled(Text, 'text-xs leading-4')
const BaseB6 = styled(Text, 'text-xs leading-4')

export const B1 = withFont(BaseB1, {
  fontDefault: 'Graphie-Regular',
  fontForJfsFlow: 'JioType',
})
export const B2 = withFont(BaseB2, {
  fontDefault: 'Graphie-Regular',
  fontForJfsFlow: 'JioType',
})
export const B3 = withFont(BaseB3, {
  fontDefault: 'Graphie-Book',
  fontForJfsFlow: 'JioType-Light',
})
export const B4 = withFont(BaseB4, {
  fontDefault: 'Graphie-SemiBold',
  fontForJfsFlow: 'JioType-Medium',
})
export const B5 = withFont(BaseB5, {
  fontDefault: 'Graphie-Regular',
  fontForJfsFlow: 'JioType',
})
export const B6 = withFont(BaseB6, {
  fontDefault: 'Graphie-Book',
  fontForJfsFlow: 'JioType-Light',
})

//BUTTON

const BaseBtnSm = styled(Text, 'text-xs leading-5')
const BaseBtn = styled(Text, 'text-sm leading-6')
export const BTN = withFont(BaseBtn, {
  fontDefault: 'Graphie-SemiBold',
  fontForJfsFlow: 'JioType-Medium',
})
export const BTN_SM = withFont(BaseBtnSm, {
  fontDefault: 'Graphie-SemiBold',
  fontForJfsFlow: 'JioType-Medium',
})
export const BTN_LG = styled(Text, 'font-[Graphie-SemiBold] text-sm leading-5')

//CAPTION
export const CTN = styled(Text, 'font-[Graphie-Regular] text-[10px] leading-4 ')

//OVERLINE
export const OLN = styled(
  Text,
  'font-[Graphie-SemiBold] text-[10px] leading-4 '
)
